module.exports = __webpack_public_path__ + "static/media/about-slide-img-1.b561391d.svg";